import { Provider, Report } from 'interfaces';
import { getUserNameWithTitlePrefix } from 'hooks/useGetUsersDisplayInfo';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const getProviderHintsFromPath = (s3Path: string | null | undefined) => {
  if (!s3Path) {
    return { providerID: null, userID: null };
  }

  const providerMatch = s3Path.match(
    /(?:^|\/)(?:providerReport|tariffProviderReport|customReport|income\/provider|providerIncome|accountsReceivable)\/([^/]+)(?:\/|$)/i
  );

  if (providerMatch?.[1]) {
    if (providerMatch[1] === 'user') {
      const userMatch = s3Path.match(
        /(?:^|\/)(?:providerIncome|accountsReceivable)\/user\/([^/]+)(?:\/|$)/i
      );
      return {
        providerID: null,
        userID: userMatch?.[1] ?? null,
      };
    }

    return {
      providerID: providerMatch[1],
      userID: null,
    };
  }

  const userMatch = s3Path.match(
    /(?:^|\/)providerIncome\/user\/([^/]+)(?:\/|$)/i
  );
  const arUserMatch = s3Path.match(
    /(?:^|\/)accountsReceivable\/user\/([^/]+)(?:\/|$)/i
  );
  return {
    providerID: null,
    userID: userMatch?.[1] ?? arUserMatch?.[1] ?? null,
  };
};

export const getReportProviderDisplay = (
  report: Report,
  providers: Provider[],
  allProvidersLabel = 'All Providers'
) => {
  if (/(?:^|\/)customReport\/site(?:\/|$)/i.test(report.s3Path)) {
    return allProvidersLabel;
  }

  const providerField = report.providerID;
  const providerFromField = providerField
    ? providers.find((provider) => provider.id === providerField)
    : undefined;
  if (providerFromField) {
    return getUserNameWithTitlePrefix(providerFromField) || 'Unknown';
  }

  const { providerID: providerIDFromPath, userID: userIDFromPath } =
    getProviderHintsFromPath(report.s3Path);
  const providerIDCandidate =
    providerIDFromPath && UUID_REGEX.test(providerIDFromPath)
      ? providerIDFromPath
      : null;
  const providerFromPath = providerIDCandidate
    ? providers.find((provider) => provider.id === providerIDCandidate)
    : undefined;
  if (providerFromPath) {
    return getUserNameWithTitlePrefix(providerFromPath) || 'Unknown';
  }

  const providerFromUser = userIDFromPath
    ? providers.find((provider) => provider.userID === userIDFromPath)
    : undefined;
  return (
    (providerFromUser && getUserNameWithTitlePrefix(providerFromUser)) || 'N/A'
  );
};
